import * as React from 'react';

export type DatePickerContextProps = {
  goToDate: (date: Date) => void | null;
  setGoToDate: (nextFn: (date: Date) => void) => void;
};

export const DatePickerContext = React.createContext<DatePickerContextProps>({
  goToDate: () => null,
  setGoToDate: () => null,
});

export const useDatePickerContext = () => React.useContext(DatePickerContext);
